export const PASSWORD_CHANGE_NOTIFICATION_MODAL_HREF =
  '/dcfront/personal/personalSettingsRegist/';
